// 用户api
import request from "./api";

// 登录-获取token
export const goLongin = (params, opts) => request("/api-oauth/oauth/token", params, { ...opts, method: "post", });
// 获取验证码图片
export const getCode = (uuid, params, opts) => request(`/api-oauth/validata/code/${uuid}`, params, opts);
// 获取用户权限菜单
export const getMenuList = (params, opts) => request(`/api-sys/sysuser/getMenuList`, params, opts);
// 获取当前用户基础信息
export const getCurrentUser = (params, opts) => request(`/api-sys/sysuser/users/current`, params, opts);
// 考试环境获取单账套信息
export const findAbForExams = (params, opts) => request(`/api-finbasic/common/findAbForExams`, params, { ...opts, method: "post", });
// 单项环境初始化触发接口
export const initDxPush = (params, opts) => request(`/api-finance-initial/dx/push`, params, { ...opts, method: "post", });
// 单项环境初始化是否完成查询接口
export const initDxCheck = (params, opts) => request(`/api-finance-initial/dx/check`, params, { ...opts, method: "post", });
// 退出
// export const logout = (token, params, opts) => request("/api-oauth/oauth2/exit/"+token, params, opts);
export const logout = (params, opts) => request('/api-oauth/v1/oauth/oauth2/logout', params, { ...opts, method: "post"});
// 初始化信息
export const getInit = (params, opts) => request(`/api-bigdata-datacleaning/init`, params, { ...opts, method: "post", });
// 手动初始化
export const clickInit = (params, opts) => request(`/api-bigdata-datacleaning/init/click`, params, { ...opts, method: "post", });
// 修改密码
export const changePassword = (params, opts) => request("/api-sys/sysuser/updatePassword", params, opts);

// 根据账套id查询账套信息接口
export const getInfoById = (params, opts) => request(`/api-finbasic/basicaccountbook/getById`, params, { ...opts, method: "post", });

// 根据用户id查询机构信息
export const findOrgsByUserId = (params, opts) => request(`/api-sys/sysorganization/findOrgsByUserId`, params, { ...opts, method: "post", });
// 根据机构Id查询页签数据、图标、logo数据
export const findByOrgIdOrDomain = (orgId, opts) => request(`/api-ai/ai/orgCustomize/findByOrgIdOrDomain?orgId=${orgId}`, {}, { ...opts, method: "get", });





// WEBPACK FOOTER //
// ./src/api/userApi.js